import './working-slots-alerts.service'
import './working-slots-api.factory';
import './working-slots-dialog-service.service'
import './working-slots-requests.service';
import './working-slots-service.service';
